import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';

interface IRadioButtonProps {
  value: string | boolean | number;
  label: string;
}

export function RadioButton(props: IRadioButtonProps) {
  const { value, label } = props;

  return <FormControlLabel value={value} control={<Radio />} label={label} />;
}
